import { Capacitor, SystemBars, SystemBarType } from "@capacitor/core";

/** spec08: true inside the Android app (Capacitor), false in the browser. */
export const isNative = Capacitor.isNativePlatform();

/** Canvas focus mode (spec08 FR14): the status bar goes away while drawing full screen. */
export async function setFullscreen(on: boolean) {
  if (!isNative) return;
  const bar = SystemBarType.StatusBar;
  await (on ? SystemBars.hide({ bar }) : SystemBars.show({ bar }));
}
